<template>
  <div id="app">
    <ImageBanner />
    <b-container>
      <b-row>
        <b-col></b-col>
        <b-col cols="8">
          <Debate />
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import ImageBanner from './components/ImageBanner'
  import Debate from './components/Debate'

  export default {
    name: 'debates',
    components: {
      ImageBanner,
      Debate
    },
  }
</script>

<style>

</style>
